import { Component } from '@angular/core';

@Component({
    selector: 'app-windows',
    templateUrl: './windows.component.svg',
    styleUrls: ['./windows.component.scss'],
})
export class WindowsComponent {}
